import { render, staticRenderFns } from "./warningTem.vue?vue&type=template&id=789aa0d7"
import script from "./warningTem.vue?vue&type=script&lang=js"
export * from "./warningTem.vue?vue&type=script&lang=js"
import style0 from "./warningTem.vue?vue&type=style&index=0&id=789aa0d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports